/* eslint-disable */
import { Node, Plugin } from 'tiptap'

export default class Image extends Node {

  get name() {
    return 'video'
  }

  get schema() {
    return {
      inline: true,
      atom: true,
      attrs: {
        src: {},
        controls: {
          default: true,
        },
        autoplay: {
          default: null,
        },
        title: {
          default: null,
        },
      },
      group: 'inline',
      draggable: true,
      parseDOM: [
        {
          tag: 'video[src]',
          getAttrs: dom => ({
            src: dom.getAttribute('src'),
            controls: dom.getAttribute('controls'),
            autoplay: dom.getAttribute('autoplay'),
            title: dom.getAttribute('title'),
          }),
        },
      ],
      toDOM: node => ['video', node.attrs],
    }
  }

  commands({ type }) {
    return attrs => (state, dispatch) => {
      const { selection } = state
      const position = selection.$cursor ? selection.$cursor.pos : selection.$to.pos
      const node = type.create(attrs)
      const transaction = state.tr.insert(position, node)
      dispatch(transaction)
    }
  }
}


// WEBPACK FOOTER //
// ./src/others/video.js